import { createContext } from 'react'
import { Logger } from '.'

const eventId = 'dummy-id'
const noopLogger: Logger = {
  captureException: () => {
    return eventId
  },
}

const LoggerContext = createContext<Logger>(noopLogger)

export default LoggerContext
